import React from 'react';
import classNames from 'classnames';
import styles from './steps.module.css';
import { IStepsProps } from './steps.models';
import CircleCheckIcon from '../../../../design/icons/circle-check.icon';
import { canGoTo } from '../stepper.helpers';
import { HorizontalScroller } from '../../horizontal-scroller/horizontal-scroller';

export function Steps({ steps, activeStepNumber, goTo }: IStepsProps) {
  return (
    <div className={classNames('card', styles.container)}>
      <HorizontalScroller scrollItemsLength={steps.length} width="100%">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const disabled = !canGoTo(!!step.disabled, index, steps);

          return (
            <button
              key={step.label}
              className={classNames(styles.step, {
                [styles.active]: stepNumber === activeStepNumber,
              })}
              aria-disabled={disabled}
              onClick={() => {
                if (disabled) return;
                goTo(stepNumber);
              }}
            >
              <span className={classNames({ invisible: !step.completed })} style={{ position: 'absolute', left: 12 }}>
                <CircleCheckIcon />
              </span>
              <span>{`${stepNumber}. ${step.label}`}</span>
            </button>
          );
        })}
      </HorizontalScroller>
    </div>
  );
}
